import {createContext} from 'react';
import {LazyLoadContextProps} from './LazyLoadContext.interface';

export const LazyLoadContext = createContext<LazyLoadContextProps>({
  disabled: false,
  addLazyLoad: () => {},
  removeLazyLoad: () => {},
});
